import * as React from 'react'
import { colors } from '@components/shared/colors'
import { Col, Row } from 'react-awesome-styled-grid'
import { Carousel } from '@components/home/Carousel'
import { H260, P16 } from '@components/shared/typography'
import SubscribeCta from '@components/SubscribeCta'
import { useSearchParams } from 'next/navigation'
import { useSelector } from 'react-redux'
import type { AppStateType } from '@reducers/appstate'

type PropsType = {
  isCoverflow: boolean,
  thematicTag?: string[],
  isSmall: boolean,
  themeTitle: string,
  themeLogLine: string
}

export function BlogCarousel (props: PropsType): React.ReactNode {
  const [showCarousel, setShowCarousel] = React.useState<boolean>(true)
  const {
    isCoverflow,
    thematicTag,
    isSmall,
    themeTitle,
    themeLogLine
  } = props
  const searchParams = useSearchParams()
  const subscriptionCta = useSelector((state: AppStateType): string => state.subscriptionCTA)
  React.useEffect((): void => {
    const h = searchParams?.get('h')
    if (h === 'n') {
      setShowCarousel(false)
    }
  }, [searchParams])
  if (!showCarousel) {
    return null
  }

  return (
    <div id="blog-preview-carousel">
      <Carousel isCoverflow={isCoverflow} thematicTag={thematicTag} isSmall={isSmall}/>
      <Row>
        <Col
          xs={4}
          sm={8}
          lg={10}
          xl={8}
          offset={{
            lg: 1,
            xl: 2
          }}
        >
          <H260 color={colors.sand} textAlign={'center'}>{themeTitle}</H260>
          <P16 color={colors.sand} textAlign={'center'}>{themeLogLine}</P16>
          <SubscribeCta ctaText={subscriptionCta} styles={{
            alignSelf: 'center',
            marginTop: 20,
            marginBottom: 36
          }}/>
        </Col>
      </Row>
    </div>
  )
}
